import React, { useCallback, useEffect } from 'react'

import {
  Icon,
  LoadingOverlay,
  LoginPage,
  useAuthSSO,
  UserType,
  useToast,
} from '@vallourec-ui/vallourec-ui'

import { useTranslation } from 'react-i18next'

import { useNavigate } from 'react-router'

// import { isAxiosError } from 'axios'

import { isAxiosError } from 'axios'

import { LoginPageProps } from '@/@types/global'
import { UserTypeProps } from '@/@types/userType'

// import { createUser } from '@/api/post'

import { createUser, getUser } from '@/api/post'
import { useApp } from '@/stores/AppStore'
import { LANGUAGES } from '@/utils/constants'
import {
  formatLoginNetworkCognito,
  transformCameCaseCognitoName,
} from '@/utils/formatCognitoName'

const Login: React.FC<LoginPageProps> = ({ systemName, appName }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { toast } = useToast()
  const { setIsLoading, isLoading, setUser, tempLocation, setTempLocation } =
    useApp()
  const { isAuthenticated, user: userCognito, groups } = useAuthSSO()
  const version = import.meta.env.VITE_REACT_APP_VERSION

  const handleOnAuthenticate = async (userData: UserType | null) => {
    if (JSON.stringify(userData) === '{}') {
      const userLocalStorage = localStorage.getItem('cognito:user')

      if (userLocalStorage && JSON.stringify(userLocalStorage) !== '{}') {
        userData = JSON.parse(userLocalStorage)
      }
    }

    if (userData?.email) {
      try {
        setIsLoading(true)
        const email = userData.email
        const response = await getUser({ email: email })

        if (JSON.stringify(response.user) === '{}') {
          const newUser = await createUser({
            email: email,
            name: `${transformCameCaseCognitoName(userData.givenName) || ''}  ${transformCameCaseCognitoName(userData.surname) || ''}`,
            lastName: '',
            network_login: formatLoginNetworkCognito(email),
            isEnabled: true,
            isAdmin: false,
          })

          if (newUser) {
            setUser(newUser)
          }
        } else {
          const data = {
            userId: response.user.id,
            email: response.user.email,
            userName: response.user.name,
            lastName: '',
            pn: response.user.pn,
            login: response.user.name,
            domain: response.user.network_login,
            areaId: '',
            isAdmin: response.user.administrator ?? false,
            isEnabled: response.user.active ?? false,
            userPosition: response.user.position,
            permissions: response.user.permissions,
            hasSignature: response.user.hasSignature,
          }
          setUser(data)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
        if (isAxiosError(err)) {
          toast({
            title: 'Error',
            description: err?.message ? err?.message : t<string>('home.error'),
            type: 'error',
          })
        }
      } finally {
        setIsLoading(false)
      }
    }
  }

  const init = async () => {
    if (isAuthenticated) {
      // const hasGroups = groups.includes('val-dev-tpi-report-teste')
      // if (!hasGroups) {
      //   setTempLocation({ path: '/access-denied' })
      //   navigate('/access-denied')
      // }
      // console.log(groups.includes('val-dev-tpi-report-admin'))

      await handleOnAuthenticate(userCognito)

      setTempLocation({ path: '/' })
      navigate('/')
    }
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])
  const onSignIn = () => {}

  const handleLoadingScreen = useCallback(() => {
    if (isLoading) return <LoadingOverlay />
  }, [isLoading])

  return (
    <>
      {handleLoadingScreen()}
      <LoginPage
        systemName=""
        appName={appName}
        t={t}
        signIn={onSignIn}
        version={version}
        applicationLogo={<Icon name="" />}
        welcomeTitle={t('login.welcome')}
        greetingsTitle={t('login.greetings')}
        buttonText={t('login.buttonText')}
        applicationLanguages={LANGUAGES}
        isSSO
        hasTermsAndPrivacy={false}
      />
    </>
  )
}

export default Login
